import Alpine from "alpinejs";

// Removing this causes js console errors...
Alpine.data("form", () => ({
    text: "",
}));

Alpine.data("formDialog", (anchorId) => ({
    abortController: null,
    active: false,
    redirected: "",
    init() {
        /* Show dialog on page-load if anchorId is in url */
        if (window.location.hash.substring(1) === anchorId) {
            this.showDialog();
        }
        /* Show dialog if hash changes to given anchorId */
        window.addEventListener("hashchange", (event) => {
            const { hash } = new URL(event.newURL);
            if (hash.substring(1) === anchorId) {
                this.showDialog();
            } else {
                if (this.active) {
                    this.hideDialog();
                }
            }
        });
        /* Listen for cross dialog communication event to handle redirects */
        window.addEventListener("form-dialog:redirect", (event) => {
            if (event.detail?.target === anchorId) {
                window.location.hash = anchorId;
                this.redirected = event.detail?.origin ?? "";
            }
        });

        /* Rewrite url on dialog close, even if it was closed via "esc" key */
        this.$refs.dialog.addEventListener("cancel", (e) => {
            e.preventDefault();
            this.hideDialog();
        });
        this.$refs.dialog.addEventListener("close", () => {
            if (window.location.hash.substring(1) === anchorId) {
                this.active = false;
                // NOTE: The url must be left as a single blank space!
                history.replaceState(null, null, " ");
            }
        });
    },
    back() {
        if (this.redirected !== "") {
            window.dispatchEvent(new CustomEvent("form-dialog:redirect", { detail: { target: this.redirected } }));
        } else {
            this.hideDialog();
        }
    },
    redirect(targetAnchorId) {
        window.dispatchEvent(
            new CustomEvent("form-dialog:redirect", {
                detail: {
                    target: targetAnchorId,
                    origin: anchorId,
                },
            })
        );
    },
    showDialog() {
        document.body.classList.add("overscroll-contain");
        /* Remove focus from open-button */
        document.activeElement.blur();
        this.active = true;
        this.abortController = new AbortController();
        this.$refs.dialog?.showModal();
        /* Attach event listener to close modal */
        this.$refs.dialog?.addEventListener(
            "click",
            (clickEvent) => {
                if (clickEvent.target === clickEvent.currentTarget) {
                    this.hideDialog();
                }
            },
            { signal: this.abortController.signal }
        );

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event : 'virtualPageView',
            virtualPagePath : anchorId,
            virtualPageTitle: anchorId
        });

        let youtubeElement = this.$refs.dialog?.querySelector('iframe[src*="youtube"]');
        if (youtubeElement) {
            youtubeElement.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        }
    },
    hideDialog() {
        this.active = false;
        this.redirected = "";
        this.abortController?.abort();
        this.$refs.dialog?.classList.add("hide");
        this.$refs.dialog?.addEventListener(
            "animationend",
            () => {
                this.$refs.dialog?.classList.remove("hide");
                this.$refs.dialog?.close();

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event : 'virtualPageViewClose',
                    virtualPagePath : anchorId,
                    virtualPageTitle: anchorId
                });

                let youtubeElement = this.$refs.dialog?.querySelector('iframe[src*="youtube"]');
                if (youtubeElement) {
                    youtubeElement.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                }
            },
            { once: true }
        );
    },
}));
